import React from 'react'
import styled from 'styled-components'
import Rate from './Rate';

const OuterContainer = styled.div`
width: 80%;
height: auto;
gap: 12px;
border: 1px solid #E3E3E3;
border-radius: 12px;
opacity: 0px;
padding: 20px;
display: flex;
flex-direction: column;
`;

const HeadText = styled.p`
flex: 1 1 10%;
font-size: 14px;
font-weight: 600;
line-height: 18.2px;
letter-spacing: 0.25px;
text-align: left;

`;

const Experience = ({ feedbackStatus }) => {
  return (
    <OuterContainer>
      {
        feedbackStatus && feedbackStatus.feedBackStatus ? (
          <div className='flex flex-col items-center justify-center gap-1'>
            <HeadText>Thanks for your feedback</HeadText>
            <HeadText style={{fontSize: '12px', color: '#767787'}}>Your feedback is important to us</HeadText>
          </div>
        ) : ( <HeadText>How was your experience?</HeadText>)
      }
        <div style={{display: 'flex', flexDirection: 'column', gap: '12px', minHeight: '250px', maxHeight: '500px', overflow: 'auto'}}>
          <Rate type = 'app' feedbackStatus = {feedbackStatus}/>
          <Rate type = 'doctor' feedbackStatus = {feedbackStatus}/>
        </div>  
    </OuterContainer>
  )
}

export default Experience